/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Wordonly2Inputs */

const en_coinvestments_wordonly2 = /** @type {(inputs: Coinvestments_Wordonly2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word only`)
};

/**
* | output |
* | --- |
* | "Word only" |
*
* @param {Coinvestments_Wordonly2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_wordonly2 = /** @type {((inputs?: Coinvestments_Wordonly2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Wordonly2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_wordonly2(inputs)
});
export { coinvestments_wordonly2 as "coInvestments_wordOnly" }